export enum VideoMessageLayout {
  ROUNDED = 'circle',
  SQUARE = 'square',
  LANDSCAPE = 'landscape'
}
